import { State } from '../../store';

export const isLoading = ({ app }: State): boolean => app.loader;
